module.exports = __webpack_public_path__ + "img/BuildCircleOutlined.77a79089.svg";